// Dev-only diagnostics: silent in production builds so nothing leaks to the console.
export const logWarn = (...args) => {
  if (process.env.NODE_ENV !== "production") console.warn(...args);
};
